    <template>
    <div>
        <page-title>站点列表</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/host/edit"><el-button type="primary" size="small" round>添加站点</el-button></router-link>
                    </div>
                    <div class="add">
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0; max-width: 100px">
                                <el-select v-model="status" clearable size="mini" placeholder="状态">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 100px">
                                <el-select v-model="type" clearable size="mini" placeholder="版本">
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="名称/域名/服务器IP"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="name" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                        <div>{{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="domain" label="服务器IP">
                    <template slot-scope="scope">
                        <template v-if="scope.row.hostIps.length > 2">
                            <div v-for="(item, index) in scope.row.hostIps" :key="item.id" v-if="index < 2">
                                {{item.ip}}
                            </div>
                            <el-button type="text" style="padding: 0;" @click="showAllIps(scope.row.hostIps)">更多...
                            </el-button>
                        </template>
                        <template v-else>
                            <div v-for="item in scope.row.hostIps" :key="item.id">{{item.ip}}</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="授权状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.status===0">审核中</span>
                        <span style="color: #67C23A" v-else-if="scope.row.status===1">已授权</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="版本">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type === 1">
                            <div>微擎版</div>
                        </template>
                        <template v-if="scope.row.type === 2">
                            <div>独立版</div>
                            <div>
                                <span>子账户: </span>
                                <span v-if="scope.row.account_num === -1">无限制</span>
                                <span v-else>{{scope.row.account_num}}个</span>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="添加时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                        </el-tooltip>
                        <el-tooltip class="item" content="更新时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status===1">
                            <router-link :to="'/dashboard/host/edit?id=' + scope.row.id">编辑</router-link>
                        </template>
                        <template v-else>-</template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
@media screen and (max-width:767px){
    .add{
        width: 70%;
    }
}
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            statusOptions: [
                {
                    value: 0,
                    label: '未授权'
                },
                {
                    value: 1,
                    label: '已授权'
                }
            ],
            typeOptions: [
                {
                    value: 1,
                    label: '微擎版'
                },
                {
                    value: 2,
                    label: '独立版'
                }
            ],
            loading: false,
            list: null,
            pagination: null,
            status: null,
            type: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'user/host/index',
                    params: {
                        page: page,
                        status: this.status,
                        type: this.type,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        showAllIps(ips) {
            let content = ''
            for (let i in ips) {
                content += `<div>${ips[i].ip}</div>`
            }
            this.$alert(content, '服务器IP', {
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
            })
        }
    }
}
</script>
